import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    connectAccount,
    getCountrySpecs,
} from '../../redux/businessAccount/detailsAction';
import { numericRegex, options } from '../../helpers/constants';

const getFieldType = (field) => {
    field = field.split('.').at(-1);
    switch (field) {
        case 'city':
        case 'line1':
        case 'postal_code':
        case 'state':
        case 'first_name':
        case 'last_name':
        case 'phone':
        case 'support_phone':
            return 'text';
        case 'email':
        case 'support_email':
            return 'email';
        case 'date':
            return 'date';
        default:
            return 'text';
    }
};

const formatFieldName = (field) => {
    const cleanField = field.replace(
        /^(individual\.|business_profile\.|dob\.|address\.)+/,
        ''
    );
    return cleanField.replace(/\./g, ' ').replace(/_/g, ' ');
};

const formatSortCode = (value) => {
    const digitsOnly = value.replace(/\D/g, '');

    return digitsOnly
        .replace(/(\d{2})(\d{2})(\d{0,2})/, '$1-$2-$3')
        .trim()
        .replace(/-$/, '');
};

const ConnectAccountModal = ({ formData, isModalOpen, handleClose }) => {
    const date = new Date();
    const dispatch = useDispatch();
    const { userData } = useSelector((state) => state.user);
    const { isLoading } = useSelector((state) => state.businessDetails);
    const formattedDate = new Intl.DateTimeFormat('en-CA').format(date);
    const [routing_number, setRouting_number] = useState('');
    const [dob, setDob] = useState('');
    const [data, setData] = useState({
        business_type: 'individual',
        mcc: '5045',
        url: 'https://bestcookieco.com',
        ip: '172.18.80.19',
        type: 'custom',
        userId: userData?.id,
        country: 'GB',
        currency: 'gbp',
        date: formattedDate,
    });

    const [countryCode, setCountryCode] = useState('+44');
    const [searchTerm, setSearchTerm] = useState('');
    const [phone, setPhone] = useState('');

    const filteredOptions = options.filter((country) =>
        country.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCountryCodeClick = (_country) => {
        setCountryCode(_country.code);
    };
    const handleInputs = (e) => {
        const { value } = e.target;

        if (numericRegex.test(value)) {
            setPhone(value);
        }
    };
    useEffect(() => {
        dispatch(getCountrySpecs('GB'));
    }, [dispatch]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'dob') {
            setDob(value);
            const [year, month, day] = value.split('-');
            setData((prev) => ({
                ...prev,
                day: day,
                month: month,
                year: year,
            }));
        } else if (files) {
            setData((prev) => ({
                ...prev,
                [name]: files[0],
            }));
        } else {
            setData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleConnectSubmit = async (e) => {
        e.preventDefault();

        const formDataObj = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            const cleanKey = key.replace(
                /^(individual\.|business_profile\.|individual.dob\.|address\.|tos_acceptance\.)+/,
                ''
            );

            formDataObj.append(cleanKey, value);
        });
        formDataObj.append('phone', countryCode + phone);

        dispatch(
            connectAccount(formDataObj, (response) => {
                if (response?.id) {
                    handleClose();
                } else {
                    console.error('Error: No response ID found');
                }
            })
        );
    };

    const excludedFields = [
        'business_profile.mcc',
        'business_profile.url',
        'business_type',
        'individual.dob.day',
        'individual.dob.month',
        'individual.dob.year',
        'tos_acceptance.ip',
        'tos_acceptance.date',
        'external_account',
        'individual.phone',
        'business_profile.support_email',
        'business_profile.support_phone',
    ];

    return (
        <div
            className={`modal fade ${isModalOpen ? 'show d-block' : ''}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: 'rgba(0,0,0,0.5)' }}
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header d-flex justify-content-between">
                        <h5 className="modal-title">Connect Payment Account</h5>
                        <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                        >
                            &times;
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleConnectSubmit}>
                            {formData?.requirements
                                ?.filter(
                                    (field) => !excludedFields.includes(field)
                                )
                                .sort((a, b) => {
                                    const priorityFields = [
                                        'individual.first_name',
                                        'individual.last_name',
                                    ];
                                    if (
                                        priorityFields.includes(a) &&
                                        !priorityFields.includes(b)
                                    )
                                        return -1;
                                    if (
                                        !priorityFields.includes(a) &&
                                        priorityFields.includes(b)
                                    )
                                        return 1;
                                    return 0;
                                })
                                .map((field) => (
                                    <div className="mb-3" key={field}>
                                        <label className="form-label c-667085 poppins f-14 fw-400 lh-20 text-capitalize">
                                            {formatFieldName(field) === 'line1'
                                                ? 'Line 1'
                                                : formatFieldName(field)}
                                        </label>
                                        <input
                                            type={getFieldType(field)}
                                            className="form-control input-filed"
                                            name={field}
                                            onChange={handleChange}
                                            required
                                            {...(getFieldType(field) === 'date'
                                                ? {
                                                      max: new Date()
                                                          .toISOString()
                                                          .split('T')[0],
                                                  }
                                                : {})}
                                        />
                                    </div>
                                ))}
                            <div>
                                <label className="form-label c-667085 poppins f-14 fw-400 lh-20">
                                    Phone Number
                                </label>
                                <div className="input-group input-filed mb-20">
                                    <span
                                        className="input-group-text border-0 py-0 ps-0 bg-transparent"
                                        id="basic-addon1"
                                    >
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-country-num dropdown-toggle"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col px-0">
                                                            {countryCode}
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                            <div className="dropdown-menu country-dropdown-menu">
                                                <input
                                                    className="country-dropdown-input"
                                                    type="text"
                                                    placeholder="Search for a country..."
                                                    value={searchTerm}
                                                    onChange={(e) =>
                                                        setSearchTerm(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                {filteredOptions.map(
                                                    (_country) => (
                                                        <p
                                                            key={_country.label}
                                                            className="dropdown-item cp"
                                                            onClick={() =>
                                                                handleCountryCodeClick(
                                                                    _country
                                                                )
                                                            }
                                                        >
                                                            {_country.flag}{' '}
                                                            {_country.label}{' '}
                                                            {_country.code}
                                                        </p>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </span>
                                    <input
                                        name="phone"
                                        value={phone}
                                        type="text"
                                        onChange={handleInputs}
                                        className="form-control border-0 py-0 box-shadow-0"
                                        placeholder="Your Number"
                                        aria-label="mobileNumber"
                                        aria-describedby="basic-addon1"
                                    />
                                </div>
                            </div>
                            {formData?.requirements.includes(
                                'external_account'
                            ) && (
                                <>
                                    <div className="mb-3">
                                        <label className="form-label c-667085 poppins f-14 fw-400 lh-20">
                                            Account Number{' '}
                                            <span className="text-muted">
                                                (e.g., 00012345)
                                            </span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control input-filed"
                                            name="ibn_number"
                                            value={data.ibn_number}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label c-667085 poppins f-14 fw-400 lh-20">
                                            Sort Code{' '}
                                            <span className="text-muted">
                                                (e.g., 10-88-00)
                                            </span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control input-filed"
                                            name="routing_number"
                                            value={routing_number}
                                            onChange={(e) =>
                                                setRouting_number(
                                                    formatSortCode(
                                                        e.target.value
                                                    )
                                                )
                                            }
                                            maxLength={8}
                                            placeholder="XX-XX-XX"
                                            required
                                        />
                                    </div>
                                </>
                            )}
                            {formData?.requirements.includes(
                                'individual.dob.day'
                            ) && (
                                <div className="mb-3">
                                    <label className="form-label c-667085 poppins f-14 fw-400 lh-20">
                                        Date of Birth
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control input-filed"
                                        name="dob"
                                        value={dob}
                                        onChange={handleChange}
                                        max={
                                            new Date(
                                                new Date().setFullYear(
                                                    new Date().getFullYear() -
                                                        18
                                                )
                                            )
                                                .toISOString()
                                                .split('T')[0]
                                        }
                                        required
                                    />
                                </div>
                            )}
                            {formData?.requirements?.includes(
                                'additional_document'
                            ) && (
                                <div className="mb-3">
                                    <label className="form-label c-667085 poppins f-14 fw-400 lh-20">
                                        Identity Document
                                    </label>
                                    <input
                                        type="file"
                                        className="form-control input-filed"
                                        name="additional_document"
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            )}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            onClick={handleConnectSubmit}
                            className="btn btn-next"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Submitting...' : 'Submit'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConnectAccountModal;
